import React from "react";

export const CartProductQuantity = ({ item, settings }) => {
  const { routes } = settings;

  const LayoutComponent: any = 'ajax-cart-quantity';

  return (
    <div className="cart-product-quantity flex items-start">
      <div className="flex flex-auto w-full">
        <div className="flex w-full items-center justify-between">
          {<LayoutComponent className="flex flex-auto">
            <div className="product-details__quantity">
              <a
                href={`${routes.cart_change_url}?id=${item.key}&quantity=${item.quantity - 1}`}
                className="flex"
                data-ajax-cart-quantity-minus
              >
                <i className={`icon icon-minus text-[8px]`} />
              </a>
              <input
                type="number"
                value={`${item.quantity}`}
                name="updates[]"
                data-ajax-cart-quantity-input={`${item.key}`}
                style={{
                  width: "36px",
                  paddingBottom: "0px",
                }}
                className="noscroll border-none h5"
                readOnly={true}
              />
              <a
                href={`${routes.cart_change_url}?id=${item.key}&quantity=${item.quantity + 1}`}
                className="flex"
                data-ajax-cart-quantity-plus
              >
                <i className={`icon icon-plus text-[8px]`} />
              </a>
            </div>
          </LayoutComponent>}

          {/* <div
              data-ajax-cart-request-button={`/cart/change?id=${item.key}&quantity=0`}
              className="cursor-pointer p-[5px]"
          >
            <i className="icon icon-x-thin lg:text-xl"></i>
          </div> */}
        </div>
      </div>
    </div>
  );
};
